import React from "react";
import "./styles.scss";
import "./mobile.scss";
import { Button, ButtonIcon, FormHeader, Tag } from "..";
import { getLanguage } from "../../utils/environment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import { motion } from "motion/react";
import { GetIconByName } from "../../config/icon";

const lan = getLanguage();

const Index = ({ data, isOpen, onClickView }) => {
  let inputElement = null;

  return (
    <>
      {/* <motion.div
        whileHover={{ x: 1 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 300 }}
      > */}
      <div className={`job-card-wrapper`} onClick={onClickView}>
        <div className={"jcw_body_wrapper"}>
          <div className={"jcw__img group-1"}>
            <img src={data?.imgUrl} alt={"job-img"} />

            <div className="button-mobile">
              <ButtonIcon
                data={{
                  iconName: "h-wrrow-right",
                  size: "xl",
                  type: "light",
                }}
              />
            </div>
          </div>
          <div className={"jcw__details group-2 "}>
            <div>
              <FormHeader
                data={{
                  formHeader: data?.titleEn,
                  lan: "en",
                  size: "xs xx",
                }}
              />
              {lan === "si" && (
                <FormHeader
                  data={{
                    formHeader: data?.titleSi,
                    lan: "si",
                    size: "xs",
                  }}
                />
              )}
            </div>
            <div className={"d-flex flex-wrap"} style={{ gap: "4px" }}>
              <Tag
                data={{
                  isIcon: false,
                  type: moment().isAfter(moment(data?.closingDate))
                    ? "red" // or "expired_tag", "red_tag", etc.
                    : "gray",
                  tagName: moment().isAfter(moment(data?.closingDate))
                    ? "Expired"
                    : "Closing date : " +
                      moment(data?.closingDate).format("DD-MMM-YYYY"),
                }}
              />
              <Tag
                data={{
                  isIcon: false,
                  type: "gray",
                  tagName: data?.organization,
                }}
              />
              <Tag
                data={{
                  isIcon: true,
                  tagIcon: "eye",
                  tagName: data?.views,
                  type: "views_tag",
                }}
              />
              <Tag
                data={{
                  isIcon: true,
                  tagIcon: "download",
                  tagName: data?.downloads,
                  type: "views_tag",
                }}
              />
            </div>
          </div>

          {data?.isArrow && (
            // <motion.div
            //   className="tncmw__action"
            //   whileHover={{ scale: 1.1, rotate: 3 }}
            //   whileTap={{ scale: 0.1 }}
            //   transition={{ type: "spring", stiffness: 300 }}
            // >
            <div className="jcw_button group-3">
              <ButtonIcon
                data={{
                  iconName: "h-wrrow-right",
                  size: "xl",
                  type: "light",
                }}
              />
            </div>
            // </motion.div>
          )}
        </div>
        {/* {isOpen && data.type === "1" && (
          <>
            <div className={"jvcmw__cb-action d-flex flex-column"}> */}
        {/* <div className={`jvcmw__cba-source`}>
                        Source :
                        <span style={{ color: "#3C71E4", textDecoration: "underline" }}>
                          www.government.lk
                        </span>
                      </div> */}
        {/* <div className={`jvcmw__cba-contact d-flex flex-row`}>
                <div
                  className={
                    "d-flex flex-row justify-content-center align-items-center"
                  }
                >
                  <div className={`jvcmw__cbac-icon`}>
                    {GetIconByName("phone")}
                  </div>
                  <div className={"d-flex flex-column"}>
                    <span className={`jvcmw__cbac-title`}>Contact No</span>
                    <span className={`jvcmw__cbac-mobile`}>0777265135</span>
                  </div>
                </div>
                <div
                  className={
                    "d-flex flex-row justify-content-center align-items-center"
                  }
                >
                  <div className={`jvcmw__cbac-icon`}>
                    {GetIconByName("mail")}
                  </div>
                  <div className={"d-flex flex-column"}>
                    <span className={`jvcmw__cbac-title`}>Email</span>
                    <span className={`jvcmw__cbac-mail`}>
                      government@gmail.com
                    </span>
                  </div>
                </div>
              </div>
              <div className={`jvcmw__cba-download`}>
                <div className={`jvcmw__cbad-title`}>
                  Download applications (PDF, DOCX)
                </div>
                <div className={`d-flex flex-row`} style={{ gap: "8px" }}>
                  <Button
                    data={{
                      btnName: "SINHALA",
                      buttonType: "black",
                      buttonSize: "xs",
                      isLoading: false,
                    }}
                    // onClick={async (e) => {
                    //   await fetchData(e);
                    // }}
                  />
                  <Button
                    data={{
                      btnName: "ENGLISH",
                      buttonType: "primary",
                      buttonSize: "xs",
                      isLoading: false,
                    }}
                    // onClick={async (e) => {
                    //   e.preventDefault();
                    //   await onClickSave(e);
                    // }}
                  />
                </div>
                <div className={`jvcmw__cbad-subtitle`}>
                  Popular! 200 applications downloaded
                </div>
              </div>
              <div
                className={`jvcmw__cba-download`}
                style={{ marginTop: "8px", marginBottom: "12px" }}
              >
                <div className={`jvcmw__cbad-title`}>Job details (png)</div>
                <div className={`d-flex flex-row`} style={{ gap: "8px" }}>
                  <Button
                    data={{
                      btnName: "SINHALA",
                      buttonType: "black",
                      buttonSize: "xs",
                      isLoading: false,
                    }}
                    // onClick={async (e) => {
                    //   await fetchData(e);
                    // }}
                  />
                  <Button
                    data={{
                      btnName: "TAMIL",
                      buttonType: "black",
                      buttonSize: "xs",
                      isLoading: false,
                    }}
                    // onClick={async (e) => {
                    //   await fetchData(e);
                    // }}
                  />
                  <Button
                    data={{
                      btnName: "ENGLISH",
                      buttonType: "primary",
                      buttonSize: "xs",
                      isLoading: false,
                    }}
                    // onClick={async (e) => {
                    //   e.preventDefault();
                    //   await onClickSave(e);
                    // }}
                  />
                </div>
              </div>
              <div
                className={"d-flex flex-wrap"}
                style={{ gap: "4px", marginBottom: "10px" }}
              >
                <Tag
                  data={{
                    isIcon: false,
                    type: "gray",
                    tagName: "Full time",
                  }}
                />
                <Tag
                  data={{
                    isIcon: false,
                    type: "gray",
                    tagName: "Servay department",
                  }}
                />
              </div>
            </div>
            <div className="jcmw_footer"></div>
          </>
        )} */}

        {/* {isOpen && data.type === "2" && (
          <>
            <div className={"jvcmw__cb-action d-flex flex-column"}>
              <div className={`jvcmw__cba-source`}>
                Source :
                <span style={{ color: "#3C71E4", textDecoration: "underline" }}>
                  www.government.lk
                </span>
              </div>
              <div className={`jvcmw__cba-contact d-flex flex-row`}>
                <div
                  className={
                    "d-flex flex-row justify-content-center align-items-center"
                  }
                >
                  <div className={`jvcmw__cbac-icon`}>
                    {GetIconByName("phone")}
                  </div>
                  <div className={"d-flex flex-column"}>
                    <span className={`jvcmw__cbac-title`}>Contact No</span>
                    <span className={`jvcmw__cbac-mobile`}>0777265135</span>
                  </div>
                </div>
                <div
                  className={
                    "d-flex flex-row justify-content-center align-items-center"
                  }
                >
                  <div className={`jvcmw__cbac-icon`}>
                    {GetIconByName("mail")}
                  </div>
                  <div className={"d-flex flex-column"}>
                    <span className={`jvcmw__cbac-title`}>Email</span>
                    <span className={`jvcmw__cbac-mail`}>
                      government@gmail.com
                    </span>
                  </div>
                </div>
              </div>
              <div
                className={`jvcmw__cba-download`}
                style={{ marginBottom: "12px" }}
              >
                <div className={`jvcmw__cbad-title`}>Apply for online</div>
                <div className={`d-flex flex-row`} style={{ gap: "8px" }}>
                  <Button
                    data={{
                      btnName: "ONLINE APPLICATION",
                      buttonType: "black",
                      buttonSize: "xs",
                      isLoading: false,
                    }}
                    // onClick={async (e) => {
                    //   await fetchData(e);
                    // }}
                  />
                </div>
              </div>

              <div className={"d-flex flex-wrap"} style={{ gap: "4px" }}>
                <Tag
                  data={{
                    isIcon: false,
                    type: "gray",
                    tagName: "Full time",
                  }}
                />
                <Tag
                  data={{
                    isIcon: false,
                    type: "gray",
                    tagName: "Servay department",
                  }}
                />
              </div>
            </div>
            <div className="jcmw_footer"></div>
          </>
        )} */}

        {/* {isOpen && data.type === "3" && (
          <>
            <div className={"jvcmw__cb-action d-flex flex-column"}>
              <div className={`jvcmw__cba-source`}>
                Source :
                <span style={{ color: "#3C71E4", textDecoration: "underline" }}>
                  www.government.lk
                </span>
              </div>
              <div className={`jvcmw__cba-contact d-flex flex-row`}>
                <div
                  className={
                    "d-flex flex-row justify-content-center align-items-center"
                  }
                >
                  <div className={`jvcmw__cbac-icon`}>
                    {GetIconByName("phone")}
                  </div>
                  <div className={"d-flex flex-column"}>
                    <span className={`jvcmw__cbac-title`}>Contact No</span>
                    <span className={`jvcmw__cbac-mobile`}>0777265135</span>
                  </div>
                </div>
                <div
                  className={
                    "d-flex flex-row justify-content-center align-items-center"
                  }
                >
                  <div className={`jvcmw__cbac-icon`}>
                    {GetIconByName("mail")}
                  </div>
                  <div className={"d-flex flex-column"}>
                    <span className={`jvcmw__cbac-title`}>Email</span>
                    <span className={`jvcmw__cbac-mail`}>
                      government@gmail.com
                    </span>
                  </div>
                </div>
              </div>
              <div className={`jvcmw__cba-download`}>
                <div className={`jvcmw__cbad-title`}>
                  Download applications (PDF, DOCX)
                </div>
                <div className={`d-flex flex-row`} style={{ gap: "8px" }}>
                  <Button
                    data={{
                      btnName: "MODEL APPPLICATION",
                      buttonType: "black",
                      buttonSize: "xs",
                      isLoading: false,
                    }}
                    // onClick={async (e) => {
                    //   await fetchData(e);
                    // }}
                  />
                </div>
              </div>
              <div
                className={`jvcmw__cba-download`}
                style={{ marginTop: "8px", marginBottom: "12px" }}
              >
                <div className={`jvcmw__cbad-title`}>Job details (png)</div>
                <div className={`d-flex flex-row`} style={{ gap: "8px" }}>
                  <Button
                    data={{
                      btnName: "SINHALA",
                      buttonType: "black",
                      buttonSize: "xs",
                      isLoading: false,
                    }}
                    // onClick={async (e) => {
                    //   await fetchData(e);
                    // }}
                  />
                  <Button
                    data={{
                      btnName: "TAMIL",
                      buttonType: "black",
                      buttonSize: "xs",
                      isLoading: false,
                    }}
                    // onClick={async (e) => {
                    //   await fetchData(e);
                    // }}
                  />
                  <Button
                    data={{
                      btnName: "ENGLISH",
                      buttonType: "primary",
                      buttonSize: "xs",
                      isLoading: false,
                    }}
                    // onClick={async (e) => {
                    //   e.preventDefault();
                    //   await onClickSave(e);
                    // }}
                  />
                </div>
              </div>
              <div className={"d-flex flex-wrap"} style={{ gap: "4px" }}>
                <Tag
                  data={{
                    isIcon: false,
                    type: "gray",
                    tagName: "Full time",
                  }}
                />
                <Tag
                  data={{
                    isIcon: false,
                    type: "gray",
                    tagName: "Servay department",
                  }}
                />
              </div>
            </div>
            <div className="jcmw_footer"></div>
          </>
        )} */}
      </div>
      {/* </motion.div> */}
    </>
  );
};

export default withRouter(Index);
